import times from 'lodash/times'

import { Skeleton } from '@/components/ui/skeleton'

export const TikTokListsPageSkeleton = () => {
  return (
    <div className="space-y-8 px-4 py-8 pb-14 xl:container lg:px-16 xl:mx-auto">
      <div className="flex items-center justify-between gap-4 max-sm:flex-col max-sm:items-start">
        <Skeleton className="h-14 w-full max-w-[270px]" />
        <Skeleton className="h-10 w-[129px]" />
      </div>
      <div className="space-y-4 rounded-2xl bg-card p-6">
        {times(3).map((i) => (
          <Skeleton
            key={i}
            className="h-10 w-full dark:bg-secondary-500"
          />
        ))}
      </div>
    </div>
  )
}
